import { createEffect } from 'effector'

import { APIResult, AxiosError } from '../../core/api/Result'
import { WhatsappAPI } from '../../services/api/Whatsapp'

export const getInfoFx = createEffect<unknown, APIResult<typeof WhatsappAPI['getInfo']>, AxiosError>(
  WhatsappAPI.getInfo,
)
